module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAIaGhgCZ/xVrmwhqnxZkmh1cjQxflghfkxJPgw5PgxdMfwpPhQZPgwJPgyJDbzM8YjUkAD0YDCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAACH5BAEHABwALAAAAAAgACAAAAXIICeOZGmeaGpu7Ka+ZtMEdAPfM63bd5rru94pJwPWhKTNrLGh/IJI1nJzuTyPvRaj1roGeCiAqJUAMqXGbwoA6KYbGbR57U5/69hTa2Df1ZkoLBUGfWZyYCUyRYVmRChejEaIJESLkQqKj34QApEIFyyBZhgbEgeFZy56HKMsEwR2qSmqQAotEQVGDhShsyJGD7cLOgkWvb52tiwXCHcsYi8bfQoWGkrObNAqkF+Kd0gc3HPg4YyTSNzn4Dm/auQxlO+BLfL1KiEAOw=="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadSW_S0.gif
// module id = fVMl
// module chunks = 47